import type { GetCausesByParentIssueIdResponseRow as CausesByParentIssueIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetCausesByParentIssueIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCausesByParentIssueIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetCausesByParentIssueIdArgs = {
  parentIssueId: string;
};

export const useLazyGetCausesByParentIssueId = createLazyQueryHook<
  UseLazyGetCausesByParentIssueIdArgs,
  CausesByParentIssueIdResponseRow[],
  GetCausesByParentIssueIdQuery
>({
  trpcQuery: (client, { parentIssueId }) =>
    client.frontend.cause.getByParentIssueId.query({
      issueId: parentIssueId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ cause: data }),
  graphqlDocument: GetCausesByParentIssueIdDocument,
  graphqlVariables: ({ parentIssueId }) => ({ _eq: parentIssueId }),
});
